import React, { useCallback, useEffect, useRef } from "react";
import PropTypes from "prop-types";

export const Observer = ({ setIsInViewPort, children }) => {
  const wrapperRef = useRef(null);
  const observerCallback = useCallback(
    entries => {
      const [entry] = entries;
      setIsInViewPort(entry.isIntersecting);
    },
    [setIsInViewPort]
  );

  useEffect(() => {
    const localRef = wrapperRef?.current;
    if (!localRef) return;

    const intersectionObserver = new IntersectionObserver(observerCallback, {});
    intersectionObserver.observe(localRef);
    return () => {
      intersectionObserver.unobserve(localRef);
    };
  }, [wrapperRef, observerCallback]);

  return <div ref={wrapperRef}>{children}</div>;
};

Observer.propTypes = {
  setIsInViewPort: PropTypes.func,
  children: PropTypes.node
};
